const win = window;
{
  win.o_global ||= {};
  win.o_util ||= {};
}
const otto = win.otto ?? {};
export {
  otto as o
};
/*                                                     */
